var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useState } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { execJsInSdk, waitForSelector } from '../integration-utils';
import { useCheckLoadedAndShow } from '../hooks/useCheckLoadedAndShow';
import { useMessageListener } from '../hooks/useMessageListener';
import useLocationLoadCompleteCallback from '../hooks/useLocationLoadCompleteCallback';
import useAdditionalParameters from '../hooks/useAdditionalParameters';
import { getWindowLocationLoadCompleteEvent, getWindowLocationLoadStartEvent, } from '../../../../utils/window-listeners';
export var PAYCOM_FINAL_DEST_REGEXP = /https:\/\/www\.paycomonline\.net\/v4\/ee\/web\.php\/app\/1$/;
function useClickRememberMe() {
    var _this = this;
    var clickRememberMe = useCallback(function (event) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!getWindowLocationLoadCompleteEvent(event))
                        return [2 /*return*/];
                    return [4 /*yield*/, waitForSelector("input[id='remember_device']")];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, execJsInSdk(function () {
                            var input = document.querySelector("input[type='checkbox']");
                            if (!input)
                                return;
                            // @ts-ignore
                            input.checked = true;
                            // @ts-ignore
                            document.querySelector("input[type='checkbox']").parentElement.style.visibility = 'hidden';
                        }, 'check_remember_device')];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useMessageListener(clickRememberMe);
}
function useHideBanner() {
    var _this = this;
    var hideBanner = useCallback(function (event) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!getWindowLocationLoadCompleteEvent(event))
                        return [2 /*return*/];
                    return [4 /*yield*/, execJsInSdk(function () {
                            var html = document.querySelector('html');
                            if (html)
                                html.style.marginTop = '0';
                        }, 'hide_download_app_banner')];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useMessageListener(hideBanner);
}
function useLogPage() {
    var _a = useState(0), standardMfaCount = _a[0], setStandardMfaCount = _a[1];
    var _b = useState(0), recoveryMfaCount = _b[0], setRecoveryMfaCount = _b[1];
    // Purely for tracking during ramp up
    var logPage = useCallback(function (event) {
        var data = getWindowLocationLoadStartEvent(event);
        if (!data)
            return;
        if (data.payload.location.includes('two-factor')) {
            var nextMfaCount = standardMfaCount + 1;
            setStandardMfaCount(nextMfaCount);
            datadogLogs.logger.info('paycom_edge_location', {
                location: "".concat(data.payload.location, "?mfaStep=").concat(nextMfaCount % 2 === 1 ? '1_method' : '2_code'),
            });
        }
        else if (data.payload.location.includes('recovery/token-password')) {
            var nextMfaCount = recoveryMfaCount + 1;
            setRecoveryMfaCount(nextMfaCount);
            datadogLogs.logger.info('paycom_edge_location', {
                location: "".concat(data.payload.location, "?mfaStep=").concat(nextMfaCount % 2 === 1 ? '1_method' : '2_code'),
            });
        }
        else {
            datadogLogs.logger.info('paycom_edge_location', {
                location: data.payload.location,
            });
        }
    }, [recoveryMfaCount, standardMfaCount]);
    useMessageListener(logPage);
}
export function usePaycom() {
    useClickRememberMe();
    useHideBanner();
    useLogPage();
    var addAdditionalParameters = useAdditionalParameters().addAdditionalParameters;
    useLocationLoadCompleteCallback(PAYCOM_FINAL_DEST_REGEXP, function (landingUrl) {
        addAdditionalParameters({ landingUrl: landingUrl });
    });
    useCheckLoadedAndShow();
}
